export default class SubscriptionViewModel {
    constructor(data) {
        this.subscriptionPeriod = data.subscriptionPeriod;
        this.subscriptionPlanId = data.subscriptionPlanId;
        this.name = data.name;
        this.monthlyMinutes = data.monthlyMinutes;
        this.usedMinutes = data.usedMinutes;
        this.priceInUSD = data.priceInUSD;
        this.overageMinutes = data.overageMinutes;
        this.status = data.status;
        this.description = data.description;
    }
}
